import { ChangeDetectionStrategy, Component, Input, Pipe, PipeTransform, forwardRef, inject } from "@angular/core";
import { ViewService } from "core/view.service";
import { Observable } from "rxjs";
import { Group } from "common/collapsible-groups/collapsible-groups.component";
import { BaseComponent } from "process/view/base.component";
import { ComponentService } from "process/view/component.service";
import { SlotService } from "common/slot.service";
import { AsyncPipe } from "@angular/common";
import { TailoringConditionsComponent } from "./tailoring-conditions.component";
import { CollapsibleGroupsComponent } from "common/collapsible-groups/collapsible-groups.component";
@Component({
	selector: "stages-tailoring-conditions-grouped",
	templateUrl: "./tailoring-conditions-grouped.component.html",
	styleUrls: ["./tailoring-conditions-grouped.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TailoringConditionsComponent,
		CollapsibleGroupsComponent,
		AsyncPipe,
		forwardRef(() => HasDependentTailoringConditionsPipe),
		forwardRef(() => DependentAsGroupPipe),
	],
})
export class TailoringConditionsGroupedComponent extends BaseComponent {
	private viewService = inject(ViewService);

	// TODO: Skipped for migration because:
	//  Your application code writes to the input. This prevents migration.
	@Input() translateNone?: string;

	selfElement$: Observable<stages.process.ProcessTreeItem>;

	constructor() {
		const componentService = inject(ComponentService);
		const slotService = inject(SlotService);

		super(componentService, slotService);
		this.selfElement$ = this.viewService.awaitSelfElementObservable();
	}
}

@Pipe({
	name: "dependentAsGroup",
	pure: true,
})
export class DependentAsGroupPipe implements PipeTransform {
	transform(dependentElements: stages.process.ViewableDependentElement[] | undefined, _args?: unknown): Group[] {
		if (!dependentElements) {
			return [];
		}
		return dependentElements.map((e) => {
			return {
				ident: e.identity,
				name: e.label,
				type: e.type,
				element: e,
				showEmpty: false,
				getMemberCount() {
					return e.tailoringConditions ? e.tailoringConditions.length : 0;
				},
			};
		});
	}
}

@Pipe({
	name: "hasDependentTailoringConditions",
	pure: true,
})
export class HasDependentTailoringConditionsPipe implements PipeTransform {
	transform(dependentElements: stages.process.ViewableDependentElement[] | undefined, _args?: unknown): boolean {
		if (!dependentElements || dependentElements.length === 0) {
			return false;
		}
		for (const dependent of dependentElements) {
			if (dependent.tailoringConditions?.length) {
				return true;
			}
		}
		return false;
	}
}
